import { StrictMode } from "react";

import { BrowserRouter } from "react-router-dom";
import { ErrorBoundary } from "shared/components";
import { Provider } from "react-redux";
import * as ReactDOM from "react-dom/client";

import App from "./core/components/app/app";
import { store } from "./core/store";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<StrictMode>
		<ErrorBoundary>
			<Provider store={store}>
				<BrowserRouter>
					<App />
				</BrowserRouter>
			</Provider>
		</ErrorBoundary>
	</StrictMode>
);
